import * as React from 'react';
import {
  Badge,
  Box,
  Heading,
  HStack,
  Text,
  useTheme,
  VStack,
} from 'native-base';
import { useAuth } from '../../hooks';
import { Loader } from '../Loader';
const { REACT_APP_STRIPE_CUSTOMER_PORTAL_URL } = process.env;

export const SubscriptionBilling = () => {
  const {
    colors: { light, muted },
  } = useTheme();
  const { loading } = useAuth();
  // tweak this once we have info about plan popularity
  const isMostPopularPlan = false;

  if (loading) return <Loader loading={loading} />;

  return (
    <VStack alignItems={'start'} w={'100%'} mt={4}>
      <Heading color="black" size="md" textAlign="left">
        Plan Details
      </Heading>
      <Text w={'60%'} mt={4} fontSize="md">
        You are currently subscribed to the <b>Essentials</b> plan. At the end
        of your plan you will be able to choose how you want to continue.
        <br />
        Like everything regarding cancellation,{' '}
        <a
          href="mailto:support@ayblehealth.com?subject=I%20would%20like%20to%20cancel%20my%20plan&body=Hello%20support%20of%20Ayblehealth%2C%20%0D%0A%0D%0AI%20am%20reaching%20out%20because%20I%20would%20like%20to%20cancel%20my%20plan."
          rel="noreferrer"
          target="_blank"
          style={{ color: 'black' }}
        >
          please contact us
        </a>
        .
      </Text>
      <Box
        backgroundColor={muted['100']}
        borderWidth={1}
        borderColor={light['400']}
        p={6}
        rounded={8}
        my={6}
      >
        <VStack>
          <HStack mb={2} width={'100%'} justifyContent={'space-between'}>
            <HStack>
              <Badge variant="solid" alignSelf="center" mr={2}>
                YOUR PLAN
              </Badge>
              {isMostPopularPlan && (
                <Badge colorScheme="success" alignSelf="center" variant="solid">
                  MOST POPULAR
                </Badge>
              )}
            </HStack>
            <Heading fontFamily="heading" size="lg">
              $25/mo
            </Heading>
          </HStack>
          <HStack mb={2} width={'100%'} justifyContent={'space-between'}>
            <Heading fontFamily="heading" size="lg">
              Essentials
            </Heading>
            <Heading fontFamily="body" size="md">
              $100 due today
            </Heading>
          </HStack>
          <Text mb={1} fontSize="lg" color="black">
            10-12 weeks program
          </Text>
          <Text fontSize="lg" color="black">
            Start your journey to better gut health with Ayble's Essentials
            program
          </Text>
        </VStack>
      </Box>
      <Heading color="black" size="md" textAlign="left" mt={2}>
        Payment Method
      </Heading>
      <Text w={'60%'} mt={4} fontSize="md">
        <a
          href={REACT_APP_STRIPE_CUSTOMER_PORTAL_URL}
          style={{ color: 'black' }}
        >
          Update
        </a>
      </Text>
    </VStack>
  );
};
